import { render } from "./rota.vue?vue&type=template&id=12d0c3a6&scoped=true"
import script from "./rota.vue?vue&type=script&lang=js"
export * from "./rota.vue?vue&type=script&lang=js"

import "./rota.vue?vue&type=style&index=0&id=12d0c3a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d0c3a6"]])

export default __exports__